/* import __COLOCATED_TEMPLATE__ from './sessions.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { task, restartableTask, timeout } from 'ember-concurrency';
import { action } from '@ember/object';
import { cached, tracked } from '@glimmer/tracking';
import { TrackedAsyncData } from 'ember-async-data';
import { mapBy } from 'ilios-common/utils/array-helpers';
const DEBOUNCE_DELAY = 250;
let CourseSessionsComponent = (_class = class CourseSessionsComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "permissionChecker", _descriptor2, this);
    _initializerDefineProperty(this, "dataLoader", _descriptor3, this);
    _initializerDefineProperty(this, "expandedSessionIds", _descriptor4, this);
    _initializerDefineProperty(this, "filterByLocalCache", _descriptor5, this);
    _initializerDefineProperty(this, "showNewSessionForm", _descriptor6, this);
    _initializerDefineProperty(this, "tableHeadersLocked", _descriptor7, this);
    _defineProperty(this, "saveSession", _buildTask(() => ({
      context: this,
      generator: function* (session) {
        session.set('course', this.args.course);
        return yield session.save();
      }
    }), null, "saveSession", null));
    _defineProperty(this, "expandSession", _buildTask(() => ({
      context: this,
      generator: function* (session) {
        yield timeout(1);
        this.expandedSessionIds = [...this.expandedSessionIds, session.id];
      }
    }), null, "expandSession", null));
    _defineProperty(this, "closeSession", _buildTask(() => ({
      context: this,
      generator: function* (session) {
        yield timeout(1);
        this.expandedSessionIds = this.expandedSessionIds.filter(id => id !== session.id);
      }
    }), null, "closeSession", null));
    _defineProperty(this, "changeFilterBy", _buildTask(() => ({
      context: this,
      generator: function* (event) {
        const value = event.target.value;
        this.filterByLocalCache = value;
        yield timeout(DEBOUNCE_DELAY);
        this.args.setFilterBy(value);
      }
    }), null, "changeFilterBy", "restartable"));
  }
  setHeaderLockedStatus(isEditing) {
    this.tableHeadersLocked = !isEditing;
  }
  get loadedCourseSessionsData() {
    return new TrackedAsyncData(this.dataLoader.loadCourseSessions(this.args.course.id));
  }
  get sessionTypesData() {
    if (!this.school) {
      return null;
    }
    return new TrackedAsyncData(this.school.sessionTypes);
  }
  get courseSessionsData() {
    return new TrackedAsyncData(this.args.course.sessions);
  }
  get schoolData() {
    return new TrackedAsyncData(this.args.course.school);
  }
  get loadedCourseSessions() {
    return this.loadedCourseSessionsData.isResolved ? this.loadedCourseSessionsData.value : null;
  }
  get sessionTypes() {
    return this.sessionTypesData?.isResolved ? this.sessionTypesData.value : [];
  }
  get courseSessions() {
    return this.courseSessionsData.isResolved ? this.courseSessionsData.value : null;
  }
  get school() {
    return this.schoolData.isResolved ? this.schoolData.value : null;
  }
  get sessions() {
    if (!this.loadedCourseSessions) {
      return false;
    }
    return this.courseSessions;
  }
  get sessionsCount() {
    return this.args.course.hasMany('sessions').ids().length;
  }
  get showExpandAll() {
    return this.sessionsWithOfferings.length;
  }
  get sessionsWithOfferings() {
    if (!this.sessions) {
      return [];
    }
    return this.sessions.filter(session => {
      const ids = session.hasMany('offerings').ids();
      return ids.length > 0;
    });
  }
  get filterByDebounced() {
    if (this.changeFilterBy.isIdle) {
      return this.args.filterBy;
    }
    return this.filterByLocalCache;
  }
  toggleExpandAll() {
    if (this.expandedSessionIds.length === this.sessionsWithOfferings.length) {
      this.expandedSessionIds = [];
    } else {
      this.expandedSessionIds = mapBy(this.sessionsWithOfferings, 'id');
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "permissionChecker", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dataLoader", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "expandedSessionIds", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "filterByLocalCache", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "showNewSessionForm", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "tableHeadersLocked", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _applyDecoratedDescriptor(_class.prototype, "setHeaderLockedStatus", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setHeaderLockedStatus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadedCourseSessionsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "loadedCourseSessionsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sessionTypesData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "sessionTypesData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "courseSessionsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "courseSessionsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "schoolData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "schoolData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleExpandAll", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleExpandAll"), _class.prototype), _class);
export { CourseSessionsComponent as default };